module.exports = __webpack_public_path__ + "1d5f9bc8a94a76c7caa4c9e12e9fc25e.png";